import {ICalendarDate} from "@pg-design/calendar-module";
import {formatDate, priceFormat} from "@pg-mono/string-utils";

import {getOfferTypeName, getOfferTypeNameWhat} from "../../../offer/helpers/OfferType";
import {OfferType} from "../../../offer/types/OfferType";
import {Currency} from "../../../types/Currency";
import {getCurrency} from "../../../utils/get_currency";

interface IProps {
    offerType?: OfferType;
    offerName?: string;
    propertyNumber?: string;
    name?: string;
    rooms?: number;
    area?: number;
    negotiation?: number | null;
    meetingDay?: ICalendarDate;
    currency?: Currency;
    additionalQuestions?: string[];
}

export const getGeneratedMessage = (props: IProps) => {
    const {area, currency, meetingDay, name, negotiation, offerName, offerType, propertyNumber, rooms, additionalQuestions} = props;

    const meetingDate = meetingDay ? new Date(meetingDay?.year, meetingDay?.month, meetingDay?.day) : null;
    const formattedMeetingDate = meetingDate && formatDate(meetingDate.toISOString(), "dd.MM");

    const offerTypeName = offerType && getOfferTypeName(offerType);
    const offerTypeNameWhat = offerType && getOfferTypeNameWhat(offerType);
    const propertyInfo = propertyNumber ? ` ${propertyNumber}` : "";
    const roomInfo = rooms ? ` ${rooms}-pokojowego` : "";
    const roomInfoFooter = rooms ? ` ${rooms}-pokojowe` : "";
    // area +-10%
    const areaFactor = 0.1;
    const areaDiff = (area || 0) * areaFactor;
    const areaInfo = area ? ` o powierzchni ${Math.floor(area - areaDiff)}-${Math.floor(area + areaDiff)} m²` : "";
    const meetingMessage =
        meetingDay &&
        `Klient chce umówić spotkanie w biurze sprzedaży w dniu ${formattedMeetingDate}${meetingDay?.hour ? ` o godzinie ${meetingDay.hour}:00` : ""}. Zadzwoń i potwierdź dostępność lub zaproponuj inny termin`;
    const negotiationMessage = negotiation && `Klient jest gotowy zakupić mieszkanie za kwotę ${priceFormat(negotiation, {unit: getCurrency({currency})})}`;

    const additionalQuestionsText =
        additionalQuestions && additionalQuestions.length > 0
            ? `\n\nKlientowi szczególnie zależy na poznaniu poniższych informacji: \n${additionalQuestions?.map((question) => `- ${question}`).join(`\n`)}.`
            : "";

    const footerText = [
        `\n\nrynekpierwotny.pl radzi:`,
        `- Ponad połowa klientów (58%) nie pamięta nazwy inwestycji ani dewelopera, ale są zainteresowani zakupem. Uwzględnij to w komunikacji.`,
        `- Skontaktuj się telefonicznie jak najszybciej, aby zaprezentować dostępne mieszkania${roomInfoFooter}.`,
        `- Pamiętaj, że skuteczność kontaktu po godzinie 18 wzrasta aż o 60%.`,
        `- Po rozmowie wyślij ofertę mailem i potwierdź jej otrzymanie SMS-em. To ważne, ponieważ nawet 47% maili trafia do katalogu „spam” lub „oferty” i pozostaje nieprzeczytanych.`
    ].join(`\n`);

    return [
        `Klient ${name} poszukuje ${offerTypeNameWhat}${roomInfo}${areaInfo}, dostępnego w Państwa ofercie.`,
        `Najbardziej interesuje go ${offerTypeName}${propertyInfo} w inwestycji ${offerName}.`,
        meetingMessage || negotiationMessage || null,
        additionalQuestionsText,
        footerText
    ]
        .filter((element) => element !== null)
        .join(" ");
};
import {ICalendarDate} from "@pg-design/calendar-module";
import {formatDate, priceFormat} from "@pg-mono/string-utils";

import {getOfferTypeName, getOfferTypeNameWhat} from "../../../offer/helpers/OfferType";
import {OfferType} from "../../../offer/types/OfferType";
import {Currency} from "../../../types/Currency";
import {getCurrency} from "../../../utils/get_currency";

interface IProps {
    offerType?: OfferType;
    offerName?: string;
    propertyNumber?: string;
    name?: string;
    rooms?: number;
    area?: number;
    negotiation?: number | null;
    meetingDay?: ICalendarDate;
    currency?: Currency;
    additionalQuestions?: string[];
}

export const getGeneratedMessage = (props: IProps) => {
    const {area, currency, meetingDay, name, negotiation, offerName, offerType, propertyNumber, rooms, additionalQuestions} = props;

    const meetingDate = meetingDay ? new Date(meetingDay?.year, meetingDay?.month, meetingDay?.day) : null;
    const formattedMeetingDate = meetingDate && formatDate(meetingDate.toISOString(), "dd.MM");

    const offerTypeName = offerType && getOfferTypeName(offerType);
    const offerTypeNameWhat = offerType && getOfferTypeNameWhat(offerType);
    const propertyInfo = propertyNumber ? ` ${propertyNumber}` : "";
    const roomInfo = rooms ? ` ${rooms}-pokojowego` : "";
    const roomInfoFooter = rooms ? ` ${rooms}-pokojowe` : "";
    // area +-10%
    const areaFactor = 0.1;
    const areaDiff = (area || 0) * areaFactor;
    const areaInfo = area ? ` o powierzchni ${Math.floor(area - areaDiff)}-${Math.floor(area + areaDiff)} m²` : "";
    const meetingMessage =
        meetingDay &&
        `Klient chce umówić spotkanie w biurze sprzedaży w dniu ${formattedMeetingDate}${meetingDay?.hour ? ` o godzinie ${meetingDay.hour}:00` : ""}. Zadzwoń i potwierdź dostępność lub zaproponuj inny termin`;
    const negotiationMessage = negotiation && `Klient jest gotowy zakupić mieszkanie za kwotę ${priceFormat(negotiation, {unit: getCurrency({currency})})}`;

    const additionalQuestionsText =
        additionalQuestions && additionalQuestions.length > 0
            ? `\n\nKlientowi szczególnie zależy na poznaniu poniższych informacji: \n${additionalQuestions?.map((question) => `- ${question}`).join(`\n`)}.`
            : "";

    const footerText = [
        `\n\nrynekpierwotny.pl radzi:`,
        `- Ponad połowa klientów (58%) nie pamięta nazwy inwestycji ani dewelopera, ale są zainteresowani zakupem. Uwzględnij to w komunikacji.`,
        `- Skontaktuj się telefonicznie jak najszybciej, aby zaprezentować dostępne mieszkania${roomInfoFooter}.`,
        `- Pamiętaj, że skuteczność kontaktu po godzinie 18 wzrasta aż o 60%.`,
        `- Po rozmowie wyślij ofertę mailem i potwierdź jej otrzymanie SMS-em. To ważne, ponieważ nawet 47% maili trafia do katalogu „spam” lub „oferty” i pozostaje nieprzeczytanych.`
    ].join(`\n`);

    return [
        `Klient ${name} poszukuje ${offerTypeNameWhat}${roomInfo}${areaInfo}, dostępnego w Państwa ofercie.`,
        `Najbardziej interesuje go ${offerTypeName}${propertyInfo} w inwestycji ${offerName}.`,
        meetingMessage || negotiationMessage || null,
        additionalQuestionsText,
        footerText
    ]
        .filter((element) => element !== null)
        .join(" ");
};
